import script from "./DeRiskCTA.vue?vue&type=script&setup=true&lang=js"
export * from "./DeRiskCTA.vue?vue&type=script&setup=true&lang=js"

import "./DeRiskCTA.vue?vue&type=style&index=0&id=886c97f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-886c97f4"]])

export default __exports__